import React from 'react';

class Tanggal extends React.Component {


    state = {
        date: ""
    };

    componentDidMount() {
        this.getDate();
    }

    getDate = () => {
        var today = new Date(),

            date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();

        this.setState({ date });
    };

    render() {
        return (
            <div className="Tanggal flex items-center space-x-4 ml-4">
                <span>-</span>
                <p>{this.state.date}</p>
            </div>
        );
    }
}

export default Tanggal;